module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"complaint":"Complaint / Report"},"zh_hk":{"complaint":"投訴 / 舉報"},"zh_cn":{"complaint":"投诉 / 举报"}}')
  delete Component.options._Ctor
}
